import { GeneralCode } from "../../../../../../../constant/GeneralCode"
import { getAllCountries } from "../../../../../../../utils/apis/getAllCountries"
import { getCities } from "../../../../../../../utils/apis/getCities"
import { getGeneralMasters } from "../../../../../../../utils/apis/getGeneralMasters"
import { UseSchedulesListVariablesUtilsProps } from "../../../../models/list"

const { PRFT, TPTT } = GeneralCode

export const useVariablesUtils = (
  props: UseSchedulesListVariablesUtilsProps,
) => {
  const { departureCountryCode } = props
  // APIを呼び出し、「渡航国」のデータ一覧を取得する。
  const { allCountries } = getAllCountries({ isFilterJapan: true })
  const { cities: departureCities } = getCities(departureCountryCode)
  // APIを呼び出し、マスタから「居住している都道府県」のデータ一覧を取得する。
  const { generalMasters: personPrefectureResidence } = getGeneralMasters(PRFT)
  // APIを呼び出し、マスタから「交通手段」のデータ一覧を取得する。
  const { generalMasters: transportation } = getGeneralMasters(TPTT)

  return {
    allCountries,
    departureCities,
    personPrefectureResidence,
    transportation,
  }
}
